<template>
  <div class="productPage" >
    <ul class="index_projectlist">
      <li v-for="(item,index) in goodsList" @click="shopDetail(item,index)">
        <a>
          <img :src="item.goods_thumb_url" alt="極草·5X冬蟲夏草純粉片（經典含片）0....">
          <h3>{{item.goods_name}}</h3>
          <p>￥{{item.price}}</p>
        </a>
      </li>
    </ul>
    <!--导航-->
    <Nav :titles="titles" :titleChild="titleChild" :navState="navState" :tipsState="tipsState"/>

    <el-pagination
      v-if="ifFEN"
      background
      layout="prev, pager, next"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :total= 'total'>
    </el-pagination>
  </div>
</template>

<script>
  import Nav from '@/components/Nav'
  //api
  import {listOfGoods} from '@/api/goods';
  //common.js
  import {setLocalStorage} from '@/utils/common';

  export default {
  name: 'ProductPage',
  components:{
     Nav
  },
  data () {
    return {
      tipsState:false,
      navState:true,
      titles: '極草產品',
      titleChild:[{name:'極草·5X冬蟲夏草純粉片',src:'ProductPage'},{name:'冬蟲夏草純粉片服用建議',src:'SuggestionTaking'},{name:'產品防偽查詢',src:'SecurityCheck'}],
      //商品数据
      goodsList:[],
      //分页
      total:0,//总长度
      pageSize:0,//每页显示数据
      total_pages:0,//页数
      page: 1,
      ifFEN:false
    }
  },
  methods:{
    //点击进入商品详情页
    shopDetail(item,index){
      this.$router.push({
          name:'ShopDetails',
          query:{
              id:item.id
            }
      });
        //数据存储
//      setLocalStorage('goodsDetail' , item)
    },
    //获取商品列表数据
    getGoodsList(page){
      listOfGoods(page).then( res =>{
        this.goodsList = res.data.data;
        this.total = res.data.meta.pagination.total;
        this.pageSize = res.data.meta.pagination.per_page;
        this.total_pages = res.data.meta.pagination.total_pages;
        if(this.total < this.pageSize){
            this.ifFEN = false
        } else {
            this.ifFEN = true
        }
      })
    },

    /*商品分页*/
    handleCurrentChange(val) {
      this.getGoodsList(val)
    },
    handleSizeChange(val) {
    },
  },
  mounted(){
      this.getGoodsList(this.page);
    window.scrollTo(0,0)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.productPage{
  .index_projectlist {
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    margin-top: 50px;
    padding-top: 50px;
    display: flex;
    flex-wrap: wrap;
    li{
      width: 230px;
      padding-bottom: 15px;
      border-bottom: 1px solid #e6e6e6;
      margin-bottom: 30px;
      margin-right: 60px;
      img{
        width: 230px;
        height: 230px;
        display: block;
      }
      h3{
        font-size: 15px;
        color: #383838;
        margin-top: 15px;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      p{
        color: #d90000;
        font-size: 18px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/product/ProductPage.vue